import { AgenturModel } from 'app/models/agentur.model';
import { AgenturStore } from '../agentur.store';
import { AgtLeadNowStore, AgtLeadNowModel } from '../agt.leadnow.store';
import { AgtLeadConsecutiveStoreNowStore, AgtLeadNowConsecutiveModel } from '../agt.leadnow.consecutive.store';
import { AgtLeadNowKwkModel, AgtLeadNowKwkStore } from '../agt.leadnowkwk.store';
import { computed, makeObservable, observable, runInAction, action } from 'mobx';
import { ISelectOpt } from 'app/components/common/Select';
import { formatKw } from 'app/utils';
import _ from 'lodash';
import { BaseUiStore } from './base.ui.store';
import Config from 'Config';

interface ILeadNowAbos {
	path: string;
	label: string;
	val?: number;
}

export enum LeadNowType {
	brutto = 'brutto',
	netto = 'netto',
}

export const LeadNowAbos: ILeadNowAbos[] = [
	{ path: 'av', label: 'Altersvorsorge', val: 0 },
	{ path: 'avverm', label: 'Altersvorsorge und Vermögensaufbau', val: 0 },
	{ path: 'baufi', label: 'Baufinanzierung', val: 0 },
	{ path: 'bausp', label: 'Bausparen', val: 0 },
	{ path: 'bu', label: 'Berufsunfähigkeit', val: 0 },
	{ path: 'fsach', label: 'Firmen Sach', val: 0 },
	{ path: 'hba', label: 'Hinterbliebenenabsicherung', val: 0 },
	{ path: 'kfz', label: 'Kfz und Motorrad', val: 0 },
	{ path: 'kv', label: 'Krankenvoll', val: 0 },
	{ path: 'kzus', label: 'Krankenzusatz und Pflege', val: 0 },
	{ path: 'psach', label: 'Privat Sach', val: 0 },
	{ path: 'reise', label: 'Reise', val: 0 },
	{ path: 'tier', label: 'Tier', val: 0 },
	{ path: 'berat', label: 'Übergreifende Beratung', val: 0 },
	{ path: 'verm', label: 'Vermögensaufbau', val: 0 },
	{ path: 'zula', label: 'Zulagengeförderte Altersvorsorge', val: 0 },
	// { path: 'kwk', label: 'Kunden werben Kunden', val: 0 },
];

LeadNowAbos.push({ path: 'kwk', label: 'Kunden werben Kunden', val: 0 });

export const LeadNowAbosOpts: ISelectOpt[] = LeadNowAbos.map((a) => {
	return {
		value: a.path,
		label: a.label,
	};
});

export const LeadNowNettoOpt = { value: 'netto', label: 'Netto' };

export class LeadNowVM {
	agt: AgenturModel;
	@observable
	item: AgtLeadNowModel;

	@observable
	consecutiveData?: AgtLeadNowConsecutiveModel;

	// make it easier to get the computeds
	[key: string]: any;

	constructor(agt: AgenturModel, leadNowData: AgtLeadNowModel, consecutiveData?: AgtLeadNowConsecutiveModel) {
		makeObservable(this);
		this.agt = agt;
		this.item = leadNowData;
		this.consecutiveData = consecutiveData;
	}

	@computed
	get consecutiveCount() {
		return this.consecutiveData?.consecutiveCount ?? 0;
	}

	@computed
	get consecutiveFirstKw() {
		return this.consecutiveData?.firstKw ?? 0;
	}

	@computed
	get consecutiveLastKw() {
		return this.consecutiveData?.lastKw ?? 0;
	}

	@computed
	get isConsecutive12() {
		return this.consecutiveCount >= 12 ? 1 : 0;
	}

	@computed
	get isCurrentLeadNowUserFit() {
		return this.agenturStatus === 'v' || this.agenturStatus === 'a' ? 1 : 0;
	}

	@computed
	get isCurrentLeadNowUserMultiGp() {
		// if (!this.items) return 0;
		if (this.item.agenturstatus === 'g') return 0;
		// return 1;
		// const brutto = this.items.filter((i: any) => i.status !== 'g');
		return this.item.totalBrutto > 0 ? 1 : 0;
		// return _.sumBy(this.item.brutto, 'leadCount') > 0 ? 1 : 0;
	}

	@computed
	get leadNowMultiGpCount() {
		if (this.isConsecutive12 === 1) {
			return this.agt.thCount ? this.agt.thCount : 0;
		}
		return 0;
	}

	@computed
	get agenturStatus() {
		return this.item ? this.item.agenturstatus : 'unbekannt';
	}

	@computed
	get agenturStatusLabel() {
		let ret = 'Unbekannt';
		switch (this.agenturStatus) {
			case 'a':
				ret = 'Aktiv';
				break;
			case 'v':
				ret = 'Urlaub';
				break;
		}

		return ret;
	}
	@computed
	get kw() {
		return this.item ? this.item.kw : 0;
	}

	@computed
	get maxKw() {
		return this.kw;
	}

	@computed
	get maxYear() {
		return this.kw ? parseInt(this.kw.toString().substring(0, 4)) : 0;
	}

	@computed
	get brutto() {
		return this.item ? this.item.totalBrutto : 0;
	}

	@computed
	get netto() {
		return this.item ? this.item.totalNetto : 0;
	}

	@computed
	get storno() {
		return this.item ? this.item.totalStorno : 0;
	}

	// Helper to return abo counts in legacy format
	_sumByAbo(abo: string) {
		if (!this.item) return { brutto: 0, netto: 0, storno: 0 };

		const aboKey = abo as keyof AgtLeadNowModel;
		return {
			brutto: (this.item as any)[`${abo}Brutto`] || 0,
			netto: (this.item as any)[`${abo}Netto`] || 0,
			storno: (this.item as any)[`${abo}Storno`] || 0,
		};
	}

	@computed
	get av() {
		return this._sumByAbo('av');
	}
	@computed
	get baufi() {
		return this._sumByAbo('baufi');
	}
	@computed
	get bausp() {
		return this._sumByAbo('bausp');
	}
	@computed
	get bu() {
		return this._sumByAbo('bu');
	}
	@computed
	get fsach() {
		return this._sumByAbo('fsach');
	}
	@computed
	get kfz() {
		return this._sumByAbo('kfz');
	}
	@computed
	get kv() {
		return this._sumByAbo('kv');
	}
	@computed
	get kzus() {
		return this._sumByAbo('kzus');
	}
	@computed
	get psach() {
		return this._sumByAbo('psach');
	}
	@computed
	get reise() {
		return this._sumByAbo('reise');
	}
	@computed
	get tier() {
		return this._sumByAbo('tier');
	}
	@computed
	get berat() {
		return this._sumByAbo('berat');
	}
	@computed
	get verm() {
		return this._sumByAbo('verm');
	}
	@computed
	get avverm() {
		return this._sumByAbo('avverm');
	}
	@computed
	get hba() {
		return this._sumByAbo('hba');
	}
	@computed
	get kwk() {
		return this._sumByAbo('kwk');
	}
	@computed
	get zula() {
		return this._sumByAbo('zula');
	}
}

export class LeadNowKwkVM {
	agt: AgenturModel;
	item?: AgtLeadNowKwkModel;

	constructor(agt: AgenturModel, item?: AgtLeadNowKwkModel) {
		this.agt = agt;
		this.item = item;
	}

	get agtId() {
		return this.agt.agtId;
	}

	get kwkStatus() {
		return this.item ? this.item.kwkStatus : '';
	}

	get kwkStatusLabel() {
		if (!this.item) {
			return 'Kein Abo';
		}
		switch (this.kwkStatus) {
			case 'ACTIVE':
				return 'Aktiv';
			case 'VACATION':
				return 'Urlaub';
			case 'DEACTIVATED':
				return 'Deaktiviert';
			default:
				return this.kwkStatus;
		}
	}
}

export class AgtLeadNowUiStore extends BaseUiStore<LeadNowVM> {
	name = 'AgtLeadNowUiStore';
	agtLeadNowStore: AgtLeadNowStore;
	agtLeadNowConsecutiveStore: AgtLeadConsecutiveStoreNowStore;
	agtLeadNowKwkStore: AgtLeadNowKwkStore;
	agenturStore: AgenturStore;

	@observable
	consecutiveDataMap: Map<number, AgtLeadNowConsecutiveModel> = new Map();

	constructor(agenturStore: AgenturStore, agtLeadNowStore: AgtLeadNowStore, agtLeadNowConsecutiveStore: AgtLeadConsecutiveStoreNowStore, agtLeadNowKwkStore: AgtLeadNowKwkStore) {
		super();
		makeObservable(this);
		this.agtLeadNowStore = agtLeadNowStore;
		this.agtLeadNowConsecutiveStore = agtLeadNowConsecutiveStore;
		this.agtLeadNowKwkStore = agtLeadNowKwkStore;
		this.agenturStore = agenturStore;
	}

	@observable
	kws: number[] = [];

	@computed
	get kwsOpts(): ISelectOpt[] {
		return this.kws.map((kw) => {
			return {
				value: kw,
				label: formatKw(kw),
			};
		});
	}

	@computed
	get minKw(): number {
		if (this.minKwCurrent) {
			return this.minKwCurrent;
		}
		return 0;
	}

	@computed
	get maxKw(): number {
		if (this.maxKwCurrent) {
			return this.maxKwCurrent;
		}
		return 0;
	}

	// Latest KW present in the data, independent of the picker selection
	@computed
	get lastKw(): number {
		return this.kws.length > 0 ? this.kws[this.kws.length - 1] : 0;
	}

	@observable
	minKwCurrent?: number;

	@observable
	maxKwCurrent?: number;

	@computed
	get currentKWItems() {
		// Filter items based on current KW range
		return this.items.filter((vm) => {
			const kwValue = vm.kw;
			if (this.minKw && kwValue >= this.minKw) {
				if (this.maxKw && kwValue <= this.maxKw) {
					return true;
				}
			}
			return false;
		});
	}

	@observable
	currentOption: ISelectOpt = LeadNowNettoOpt;

	@computed
	get currentKwOptionItems() {
		if (this.currentOption.value === 'netto') {
			return this.currentKWItems;
		}
		const filtered = this.currentKWItems.filter((i) => {
			return _.get(i, this.currentOption.value + '.netto') > 0;
		});
		return filtered;
	}

	@computed
	get currentEmpties() {
		return this.allAgtButEmpty.filter((emptyItem) => {
			return !this.currentKwOptionItems.some((currentItem) => currentItem.agt.agtId === emptyItem.agt.agtId);
		});
	}

	@observable
	allAgtButEmpty: LeadNowVM[] = [];

	async _baseLoad() {
		// Load agencies only - no data loading yet
		const agts = await this.agenturStore.findAll();

		// Get available KWs from the analytics store and load consecutive data in parallel
		const [distinctKws, consecutiveData] = await Promise.all([this.agtLeadNowStore.getDistinctKWs(), this.agtLeadNowConsecutiveStore.loadForCurrentYear()]);

		runInAction(() => {
			this.kws = distinctKws;
			// Set default KW range to the most recent week ONLY if not already set
			// This allows query parameters to take precedence
			if (this.kws.length > 0 && !this.maxKwCurrent && !this.minKwCurrent) {
				this.maxKwCurrent = this.kws[this.kws.length - 1];
				this.minKwCurrent = this.kws[this.kws.length - 1];
			}

			// Build consecutive data map for quick lookup by vtnrId
			this.consecutiveDataMap.clear();
			consecutiveData.forEach((item) => {
				this.consecutiveDataMap.set(item.vtnrId, item);
			});
		});
	}


	@action
	async loadConsectutiveData(maxKw: number) {
		const cacheKey = `AgtLeadNowUiStore.loadConsectutiveData${maxKw}`;

		return this.withCache(
			cacheKey,
			async () => {
				console.time('AgtLeadNowUiStore.loadConsectutiveData');
				await this.load();

				// Load data for the specified KW from analytics store
				const agenturenWithoutAda = this.agenturStore.agenturenWithoutAda;


				const data = await this.agtLeadNowStore.loadByMaxKw();

				const res: LeadNowVM[] = [];
				const empties: LeadNowVM[] = [];

				runInAction(() => {
					// Group leadnow data by agency
					agenturenWithoutAda.forEach((agt) => {
						const agtData = data.find((d) => d.agtId === agt.agtId);
						const consecutiveData = this.consecutiveDataMap.get(agt.agtId);
						if (agtData) {
							const vm = new LeadNowVM(agt, agtData, consecutiveData);
							res.push(vm);
						}

						// Create empty placeholder for agencies without data
						const emptyData = new AgtLeadNowModel({
							aid: agt.agtId,
							kw: maxKw,
							as: '',
						});
						empties.push(new LeadNowVM(agt, emptyData, consecutiveData));
					});
				});

				console.timeEnd('AgtLeadNowUiStore.loadConsectutiveData');
				return res;
			},
			{
				cacheResult: true,
			},
		);
	}


	@action
	async loadKwkItems(): Promise<LeadNowKwkVM[]> {
		const cacheKey = 'AgtLeadNowUiStore.loadKwkItems';

		return this.withCache(
			cacheKey,
			async () => {
				await this.agenturStore.findAll();
				const agts = this.agenturStore.agenturenWithoutAda;

				// Latest monthly KwK snapshot; agencies without a row have no abo.
				const data = await this.agtLeadNowKwkStore.findLatest();
				const dataMap = new Map(data.map((d) => [d.agtId, d]));

				return agts.map((agt) => new LeadNowKwkVM(agt, dataMap.get(agt.agtId)));
			},
			{
				cacheResult: true,
			},
		);
	}

	@action
	async aggregateAgtsByBm(minKw: number, maxKw: number): Promise<LeadNowVM[]> {
		// load() first, so the current range can serve as fallback. Callers pass the
		// minKw/maxKw getters, which are 0 before load — that would query `kw BETWEEN 0 AND 0`.
		await this.load();
		minKw = minKw || this.minKw;
		maxKw = maxKw || this.maxKw;

		const cacheKey = `AgtLeadNowUiStore.aggregateAgtsByBm${minKw}-${maxKw}`;

		return this.withCache(
			cacheKey,
			async () => {
				console.time('AgtLeadNowUiStore.aggregateAgtsByBm');

				// Load aggregated data from server (aggregation happens in SQL via GROUP BY)
				const agenturenWithoutAda = this.agenturStore.agenturenWithoutAda;
				const data = await this.agtLeadNowStore.aggregateByKwRange(minKw, maxKw);

				const res: LeadNowVM[] = [];
				const empties: LeadNowVM[] = [];

				runInAction(() => {
					// Create VMs for all agencies
					agenturenWithoutAda.forEach((agt) => {
						const agtData = data.find((d) => d.agtId === agt.agtId);
						const consecutiveData = this.consecutiveDataMap.get(agt.agtId);
						if (agtData) {
							const vm = new LeadNowVM(agt, agtData, consecutiveData);
							res.push(vm);
						}

						// Create empty placeholder for agencies without data
						const emptyData = new AgtLeadNowModel({
							aid: agt.agtId,
							kw: maxKw,
							as: '',
						});
						empties.push(new LeadNowVM(agt, emptyData, consecutiveData));
					});

					this.items = res;
					this.allAgtButEmpty = empties;
				});

				console.timeEnd('AgtLeadNowUiStore.aggregateAgtsByBm');
				return res;
			},
			{
				cacheResult: true,
			},
		);
	}

	@action
	async loadLeadNowHistoryLast12Weeks(ids: number | number[]): Promise<
		{
			kw: string;
			kwRaw: number;
			brutto: number;
			storno: number;
			netto: number;
		}[]
	> {
		const isAggregated = Array.isArray(ids);
		const cacheKey = isAggregated
			? `AgtLeadNowUiStore.loadLeadNowHistoryLast12Weeks_${ids.sort().join('_')}`
			: `AgtLeadNowUiStore.loadLeadNowHistoryLast12Weeks_${ids}`;

		return this.withCache(
			cacheKey,
			async () => {
				// Ensure base data is loaded
				await this.load();

				// Get last 12 available weeks
				const last12Kws = this.kws.slice(-12);

				// For aggregated view, load all agencies' data
				if (isAggregated) {
					const agtIds = ids as number[];

					// Load data for each week and aggregate
					const result = await Promise.all(
						last12Kws.map(async (kw) => {
							const allAgencyData = await this.agtLeadNowStore.loadByKw(kw);

							let totalBrutto = 0;
							let totalStorno = 0;
							let totalNetto = 0;

							agtIds.forEach((agtId) => {
								const agtData = allAgencyData.find((m) => m.agtId === agtId);
								if (agtData) {
									totalBrutto += agtData.totalBrutto || 0;
									totalStorno += agtData.totalStorno || 0;
									totalNetto += agtData.totalNetto || 0;
								}
							});

							return {
								kw: formatKw(kw),
								kwRaw: kw,
								brutto: totalBrutto,
								storno: totalStorno,
								netto: totalNetto,
							};
						})
					);

					return result;
				} else {
					// Single agency view
					const agtId = ids as number;

					const result = await Promise.all(
						last12Kws.map(async (kw) => {
							const allAgencyData = await this.agtLeadNowStore.loadByKw(kw);
							const agtData = allAgencyData.find((m) => m.agtId === agtId);

							return {
								kw: formatKw(kw),
								kwRaw: kw,
								brutto: agtData?.totalBrutto || 0,
								storno: agtData?.totalStorno || 0,
								netto: agtData?.totalNetto || 0,
							};
						})
					);

					return result;
				}
			},
			{
				cacheResult: true,
			},
		);
	}
}
